import { DataSyncRunSchema } from '../../shared/data-sync';
export const startPersonioDataSyncContract = {
    method: 'POST',
    path: '/api/v2/data-sync/runs/personio',
    description: 'Read Personio and start a sync run; an incomplete or failed read returns the run as failed with its failureCode',
    responseSchema: DataSyncRunSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - a sync run is already running, Personio is not linked, its stored credentials can no longer be read, or the run lost its lock (stale)'
        }
    }
};

//# sourceMappingURL=start-personio-data-sync.contract.js.map